
program HBMWebSpl;



uses
  Vcl.Forms,
  WEBLib.Forms,
  WEBLib.WebTools,
  System.SysUtils,
  PrjFormDefault in '..\HbmWebSPLBT\_WebForms\PrjFormDefault.pas'{*.html},
  HBMWebDef in '..\..\SRC\HBMWebDef.pas',
  PrjClassWebClientDataAccess in '..\..\SRC\PrjClassWebClientDataAccess.pas',
  wxBaseClassWebTools in '..\..\..\..\..\MFC - FrameWork\trunk\_CommonFiles\_WebAccess\wxBaseClassWebTools.pas',
  PrjClassHBMDataAccess in '..\..\SRC\PrjClassHBMDataAccess.pas',
  PrjFormDecisionData in '_WebForms\PrjFormDecisionData.pas'{*.html},
  PrjDialogLogin in '..\HbmWebSPLBT\_WebForms\PrjDialogLogin.pas'{*.html},
  PrjFormSeminarKenndaten in '_WebForms\PrjFormSeminarKenndaten.pas'{*.html},
  PrjFormWirkungsKurven in '_WebForms\PrjFormWirkungsKurven.pas'{*.html},
  PrjFormPeriodenUnabhaengigeDaten in '_WebForms\PrjFormPeriodenUnabhaengigeDaten.pas'{*.html},
  PrjFormAusgangsLoesung in '_WebForms\PrjFormAusgangsLoesung.pas'{*.html},
  PrjFormPeriodicData in '_WebForms\PrjFormPeriodicData.pas'{*.html},
  PrjFormPDFDisplay in '_WebForms\PrjFormPDFDisplay.pas'{*.html},
  PrjFormMain in 'PrjFormMain.pas'{*.html},
  PrjClassHBMDefaultData in '..\..\SRC\PrjClassHBMDefaultData.pas',
  HBMWebData in '..\..\SRC\HBMWebData.pas',
  PrjFormTLNReportSelection in '_WebForms\PrjFormTLNReportSelection.pas'{*.html},
  PrjClassTokenInformation in '..\..\SRC\PrjClassTokenInformation.pas',
  PrjClassHelperClasses in '..\..\SRC\PrjClassHelperClasses.pas',
  PrjConstants in '..\..\SRC\_ProjectClasses\_General\PrjConstants.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TPrjFormsMain, PrjFormsMain);
  Application.CreateFormDirect(TDataModule1, DataModule);
  Application.Run;
end.
